module.exports = __webpack_public_path__ + "img/pole-status-yellow.5366a940.png";